/**
 * "undo redo | bold italic" -> [["undo","redo"], ["bold","italic"]]
 *
 * Deliberately the same pipe-delimited format TinyMCE's `toolbar` option uses,
 * so migrating a call site is a copy-paste of the string it already has.
 * An array is passed through untouched.
 */
export default function parseToolbar(spec) {
  if (Array.isArray(spec)) return spec;
  return String(spec || "")
    .split("|")
    .map((group) => group.trim().split(/\s+/).filter(Boolean))
    .filter((group) => group.length > 0);
}
